import { Fragment } from 'react';
import { FiPhoneCall, FiUser } from 'react-icons/fi'
import { Link } from 'react-router-dom';
import { logout, tokenExists } from 'slices/auth';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import './index.scss';

interface TNProps {
}

function TopNav(props: TNProps) {
    const isAuthenticated = useAppSelector(tokenExists)
    const dispatch = useAppDispatch()
    return (
        <div className="b-grey desktop">
            <div className="max-width p-x topNav">
                <div className="topNav_left">
                    <i className="topNav_left-icon"><FiPhoneCall /></i>
                    We are available 24/7, Need help? Call Us: <a href="tel:+2349155202857">+2349155202857</a>
                </div>
                <div className="topNav_right">
                    <a href="#!">about us</a>
                    <span className="vertical-line"></span>
                    <a href="#!">contact us</a>
                    <span className="vertical-line"></span>
                    {isAuthenticated ? (
                        <Fragment>
                            <Link to='/dashboard'>my account</Link>
                            <span className="vertical-line"></span>
                            <Link to='/' onClick={() => dispatch(logout())}>logout</Link>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <Link to='/login'><i className="topNav_right-icon"><FiUser /></i>login</Link>
                        </Fragment>
                    )}
                </div>
            </div>
        </div>
    )
}

export {
    TopNav
}